<template>

    <master-panel
            @edit:client="onClientEdit"
            @appointment:cancel="onAppointmentCancel"
            @attention:start="onAttentionStart"
            @attention:end="onAttentionEnd"
            @change:events="onEventsChange"
    >

        <template v-slot:summary="data">
            <attention-summary v-if="eventDetails" :event="eventDetails" style="border-radius: 10px" class="mt-2 text-left"/>
        </template>

        <template v-slot:body="data">
            <div v-if="eventDetails">


              <client-history-title
                  class="mt-4"
                  title="Comentarios de la cita:"
                  icon="fas fa-comment" />

              <v-card class="mt-2 kim-card">
                <v-card-text>
                  <v-textarea v-model="comments" :loading="savingComments" filled></v-textarea>
                </v-card-text>
              </v-card>


            </div>
        </template>


    </master-panel>

</template>

<script>

import {ApiUtils} from "@/utils/ApiUtils";
import MasterPanel from './MasterPanel'
import AttentionScreenMixin from '@/mixins/AttentionScreenMixin'
import {getPhysicalExamName} from "@/utils/Strings";
import {debounce} from "@/utils/Common";
import AttentionSummary from '@/components/appointments/attention/AttentionSummary'

    export default{
        components: {
            AttentionSummary,
          MasterPanel
        },
        mixins: [AttentionScreenMixin],
        data(){
            return {
              savingComments: false,
              comments: ''
            }
        },
        mounted(){
          const vm = this
          vm.setDefaults();
        },
        methods: {

          debouncedUpdateComments: debounce(function(){
            if(!this.eventDetails || this.eventDetails.event_status_id !== 4) return
            this.updateComments()
          }, 1000),

          async updateComments(){
            const vm = this
            if(vm.savingComments || !vm.currentEvent) return

            if(vm.eventDetails && vm.eventDetails.comments === vm.comments) return

            vm.savingComments = true
            const response = await ApiUtils.makePatch(`event/${vm.currentEvent.id}/appointment/comment`, null, {
              comment: vm.comments
            })
            vm.savingComments = false

            if(!response.ok){
              const json = await response.json()
              return vm.showSnackBar({
                text: json.message || 'Ha ocurrido un error intentando consultar los datos',
                color: 'error'
              })
            }

            const json = await response.json()
            vm.eventDetails.comments = json.result.comment

          },
          setDefaults(){
            const vm = this
            if(vm.eventDetails && vm.eventDetails.comments){
              vm.comments = vm.eventDetails.comments
            }else{
              vm.comments = ''
            }
          }

        },
        computed: {
          getPhysicalExamName
        },
      watch:{
          comments(){
            this.debouncedUpdateComments()
          },
        eventDetails(){
          const vm = this
          vm.setDefaults()
        }
      }
    }
</script>
